/**
 * SxaAssessmentNavTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import axios from "axios";

class SxaAssessmentNavTile extends React.Component {
    constructor(props) {
        super(props);
        // Assign Q ref to state for refresh
        this.state = {
            q: props.q,
            backenabled: !props.q.firstQuestion,
            nextenabled: (!props.q.lastQuestion || props.q.scoreDefaulted === true)
        };

        this.handleBackClick = this.handleBackClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
    }

    changeQuestion(newQ) {
        // Force re-render
        this.setState( state => ({
            q: newQ,
            backenabled: !newQ.firstQuestion,
            nextenabled: (!newQ.lastQuestion || newQ.scoreDefaulted === true)
        }) );
    }

    handleBackClick(e) {
        e.preventDefault();
        //console.log("Q-Nav BACK clicked");

        // Move the Assessment Q-cursor to the previous Question (if any)
        var url = 'api/assessment/previousQuestion';
        axios.get(url)
            .then(response => {
                //console.log(response.data);

                // Signal the A container re. Q nav - callback function
                this.props.handleQChange(response.data);
            })
            .catch(err => console.error(err))
    }

    handleNextClick(e) {
        e.preventDefault();
        //console.log("Q-Nav NEXT clicked");

        // Move the Assessment Q-cursor to the next Question (if any)
        var url = 'api/assessment/nextQuestion';
        axios.get(url)
            .then(response => {
                //console.log(response.data);

                // Signal the A container re. Q nav - callback function
                this.props.handleQChange(response.data);
            })
            .catch(err => console.error(err))
    }

    // N.B. Add enough bottom padding to avoid button overlap by footer (minHeight 32px
    // was 12px; changed to 42px
    render() {
        return (
            <React.Fragment>
                {this.props.q ? (
                    <div style={{ paddingTop: 12, paddingBottom: 42}}>
                        {this.state.backenabled ?
                            <Button onClick={this.handleBackClick} variant="contained" color="primary"
                                    style={{marginRight: 6, backgroundColor: 'white', color: '#1976D2'}}>
                                Back
                            </Button>
                            :
                            <Button variant="contained" color="primary"
                                    style={{marginRight: 6, disabled: "true", backgroundColor: "lightgrey", color: "darkgrey"}}>
                                Back
                            </Button>
                        }
                        {this.state.nextenabled ?
                            <Button onClick={this.handleNextClick} variant="contained" color="primary"
                                    style={{marginLeft: 6, backgroundColor: '#1976D2'}}>
                                Next
                            </Button>
                            :
                            <Button variant="contained" color="primary"
                                    style={{marginLeft: 6, disabled: "true", backgroundColor: "lightgrey", color: "darkgrey"}}>
                                Next
                            </Button>
                        }
                    </div>
                ) : "No Question found"}
            </React.Fragment>
        );
    }
}

export default SxaAssessmentNavTile;